/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateNotificationOutputDTO } from '../model';
// @ts-ignore
import { CreateNotificationRequest } from '../model';
// @ts-ignore
import { GetNotificationsOutputDTO } from '../model';
// @ts-ignore
import { HTTPValidationError } from '../model';
// @ts-ignore
import { UpdateNotificationOutputDTO } from '../model';
// @ts-ignore
import { UpdateNotificationRequest } from '../model';
/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Notification
         * @param {CreateNotificationRequest} createNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationDockschedulingNotificationsPost: async (createNotificationRequest: CreateNotificationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNotificationRequest' is not null or undefined
            assertParamExists('createNotificationDockschedulingNotificationsPost', 'createNotificationRequest', createNotificationRequest)
            const localVarPath = `/dockscheduling/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationDockschedulingNotificationsNotificationIdDelete: async (notificationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('deleteNotificationDockschedulingNotificationsNotificationIdDelete', 'notificationId', notificationId)
            const localVarPath = `/dockscheduling/notifications/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Notifications
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsDockschedulingNotificationsGet: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getNotificationsDockschedulingNotificationsGet', 'locationId', locationId)
            const localVarPath = `/dockscheduling/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Notification
         * @param {string} notificationId 
         * @param {UpdateNotificationRequest} updateNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationDockschedulingNotificationsNotificationIdPut: async (notificationId: string, updateNotificationRequest: UpdateNotificationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('updateNotificationDockschedulingNotificationsNotificationIdPut', 'notificationId', notificationId)
            // verify required parameter 'updateNotificationRequest' is not null or undefined
            assertParamExists('updateNotificationDockschedulingNotificationsNotificationIdPut', 'updateNotificationRequest', updateNotificationRequest)
            const localVarPath = `/dockscheduling/notifications/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Notification
         * @param {CreateNotificationRequest} createNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotificationDockschedulingNotificationsPost(createNotificationRequest: CreateNotificationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateNotificationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotificationDockschedulingNotificationsPost(createNotificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotificationDockschedulingNotificationsNotificationIdDelete(notificationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNotificationDockschedulingNotificationsNotificationIdDelete(notificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Notifications
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationsDockschedulingNotificationsGet(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNotificationsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationsDockschedulingNotificationsGet(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Notification
         * @param {string} notificationId 
         * @param {UpdateNotificationRequest} updateNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationDockschedulingNotificationsNotificationIdPut(notificationId: string, updateNotificationRequest: UpdateNotificationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateNotificationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationDockschedulingNotificationsNotificationIdPut(notificationId, updateNotificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Notification
         * @param {CreateNotificationRequest} createNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationDockschedulingNotificationsPost(createNotificationRequest: CreateNotificationRequest, options?: any): AxiosPromise<CreateNotificationOutputDTO> {
            return localVarFp.createNotificationDockschedulingNotificationsPost(createNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationDockschedulingNotificationsNotificationIdDelete(notificationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteNotificationDockschedulingNotificationsNotificationIdDelete(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Notifications
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsDockschedulingNotificationsGet(locationId: string, options?: any): AxiosPromise<GetNotificationsOutputDTO> {
            return localVarFp.getNotificationsDockschedulingNotificationsGet(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Notification
         * @param {string} notificationId 
         * @param {UpdateNotificationRequest} updateNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationDockschedulingNotificationsNotificationIdPut(notificationId: string, updateNotificationRequest: UpdateNotificationRequest, options?: any): AxiosPromise<UpdateNotificationOutputDTO> {
            return localVarFp.updateNotificationDockschedulingNotificationsNotificationIdPut(notificationId, updateNotificationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @summary Create Notification
     * @param {CreateNotificationRequest} createNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public createNotificationDockschedulingNotificationsPost(createNotificationRequest: CreateNotificationRequest, options?: any) {
        return NotificationApiFp(this.configuration).createNotificationDockschedulingNotificationsPost(createNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Notification
     * @param {string} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public deleteNotificationDockschedulingNotificationsNotificationIdDelete(notificationId: string, options?: any) {
        return NotificationApiFp(this.configuration).deleteNotificationDockschedulingNotificationsNotificationIdDelete(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Notifications
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotificationsDockschedulingNotificationsGet(locationId: string, options?: any) {
        return NotificationApiFp(this.configuration).getNotificationsDockschedulingNotificationsGet(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Notification
     * @param {string} notificationId 
     * @param {UpdateNotificationRequest} updateNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public updateNotificationDockschedulingNotificationsNotificationIdPut(notificationId: string, updateNotificationRequest: UpdateNotificationRequest, options?: any) {
        return NotificationApiFp(this.configuration).updateNotificationDockschedulingNotificationsNotificationIdPut(notificationId, updateNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
